'use client'

import { toQuotes } from '@/feature/quotes/routing/quote.routing'
import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Icon } from '@/ui/icons/icon/Icon'
import {
  NavigationCard,
  type NavigationCardSize,
} from '@/ui/cards/navigation-card/NavigationCard.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import {
  AccountDrawer_QuoteNotificationConfigDocument,
  AccountHomeSliderMyQuotesTileDocument,
} from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query AccountHomeSliderMyQuotesTile {
    currentUser {
      id
      hasProcessingQuotes
    }
  }
`)

export function AccountHomeSliderMyQuotesTile({
  size,
  className,
}: {
  size: NavigationCardSize
  className?: string
}) {
  const { data, loading } = useQuery(
    AccountHomeSliderMyQuotesTileDocument,
    APOLLO_CLIENT_SIDE_OPTIONS,
  )

  const { data: configData } = useQuery(
    AccountDrawer_QuoteNotificationConfigDocument,
    APOLLO_CLIENT_SIDE_OPTIONS,
  )

  const displayQuoteNotification = !!configData?.config?.quotation?.isQuotationEnabled

  const { t } = useTranslation(['accountHomeSlider'])

  const hasProcessingQuotes = data?.currentUser?.hasProcessingQuotes ?? false

  return (
    <NavigationCard
      size={size}
      href={toQuotes}
      icon={<Icon.FileText />}
      className={className}
      hasNotification={!loading && hasProcessingQuotes && displayQuoteNotification}
      trackingData={{
        event: 'gaEvent',
        eventCategory: 'homepage',
        eventAction: 'bandeau accueil connecté',
        eventLabel: 'clic | Devis',
      }}
    >
      {t('accountHomeSlider:quotes')}
    </NavigationCard>
  )
}
